import { fork } from 'redux-saga/effects';
import watchLoadMeetAndGreetTrips from './watchLoadMeetAndGreetTrips';
import watchUpdateMeetAndGreetTrip from './watchUpdateMeetAndGreetTrip';


export default function* suggestedMeetAndGreetTrips() {
  yield fork(watchLoadMeetAndGreetTrips);
  yield fork(watchUpdateMeetAndGreetTrip);
}
